import React from 'react'
import './History.css'

const History = (props) => {
    return (
        <div className="row justify-content-center m-0">
            <div className="History">
                <div className="row m-0">
                    <div className="col-1 small-ord-history">
                        تاریخ:
                    </div>
                    <div className="col-2 small-ord-history">
                        {props.history.date}
                    </div>
                    <div className="col-1 small-ord-history">
                        ساعت:
                    </div>
                    <div className="col-2 small-ord-history">
                        {props.history.time}
                    </div>
                    <div className="col-1 small-ord-history">
                        کاربر:
                    </div>
                    <div className="col-2 small-ord-history">
                        {props.history.username}
                    </div>
                    <div className="col-1 small-ord-history">
                        عملیات:
                    </div>
                    <div className="col-2 small-ord-history">
                        {props.history.orderState}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default History